import { createRouter, createWebHistory } from "vue-router";
import { useAuth } from "@/composables/useAuth";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/pages/LoginPage.vue"),
      meta: { requiresAuth: false },
    },
    {
      path: "/",
      name: "dashboard",
      component: () => import("@/pages/DashboardPage.vue"),
    },
    {
      path: "/providers",
      name: "providers",
      component: () => import("@/pages/ProvidersPage.vue"),
    },
    {
      path: "/providers/new",
      name: "provider-new",
      component: () => import("@/pages/ProviderNewPage.vue"),
    },
    {
      path: "/providers/:id",
      name: "provider-detail",
      component: () => import("@/pages/ProviderDetailPage.vue"),
    },
    {
      path: "/providers/:id/edit",
      name: "provider-edit",
      component: () => import("@/pages/ProviderEditPage.vue"),
    },
    {
      path: "/anchors",
      name: "anchors",
      component: () => import("@/pages/AnchorsPage.vue"),
    },
    {
      path: "/anchors/new",
      name: "anchor-new",
      component: () => import("@/pages/AnchorNewPage.vue"),
    },
    {
      path: "/anchors/:id",
      name: "anchor-detail",
      component: () => import("@/pages/AnchorDetailPage.vue"),
    },
    {
      path: "/anchors/:id/edit",
      name: "anchor-edit",
      component: () => import("@/pages/AnchorEditPage.vue"),
    },
    {
      path: "/document-types",
      name: "document-types",
      component: () => import("@/pages/DocumentTypesPage.vue"),
    },
    {
      path: "/document-types/new",
      name: "document-type-new",
      component: () => import("@/pages/DocumentTypeNewPage.vue"),
    },
    {
      path: "/document-types/:id",
      name: "document-type-detail",
      component: () => import("@/pages/DocumentTypeDetailPage.vue"),
    },
    {
      path: "/document-types/:id/edit",
      name: "document-type-edit",
      component: () => import("@/pages/DocumentTypeEditPage.vue"),
    },
    {
      path: "/ai-usage",
      name: "ai-usage",
      component: () => import("@/pages/AIUsagePage.vue"),
    },
    {
      path: "/ai-usage/:anchorId",
      name: "ai-usage-detail",
      component: () => import("@/pages/AIUsageDetailPage.vue"),
    },
    {
      path: "/api-docs",
      name: "api-docs",
      component: () => import("@/pages/ApiDocsPage.vue"),
    },
    {
      path: "/error-codes",
      name: "error-codes",
      component: () => import("@/pages/ErrorCodesPage.vue"),
    },
    {
      path: "/architecture",
      name: "architecture",
      component: () => import("@/pages/ArchitecturePage.vue"),
    },
  ],
});

router.beforeEach((to) => {
  if (to.meta.requiresAuth === false) return true;

  const { isAuthenticated } = useAuth();
  if (!isAuthenticated.value) {
    return { name: "login" };
  }

  return true;
});

export default router;
